/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.sbf-time-slot', {
            parent: 'board.project-detail',
            url: '/sbf-time-slot?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.sbfTimeSlot.home.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/sbf-time-slot/sbf-time-slots.html',
                    controller: 'SbfTimeSlotController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fromTime,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sbfTimeSlot');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.sbf-time-slot.new', {
            parent: 'board.project-detail.sbf-time-slot',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/sbf-time-slot/sbf-time-slot-dialog.html',
                    controller: 'SbfTimeSlotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                amount: 1,
                                fromTime: null,
                                toTime: null,
                                maxParticipants: 2,
                                id: null
                            };
                        },
                        entityProject: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.sbf-time-slot', null, { reload: 'board.project-detail.sbf-time-slot' });
                }, function() {
                    $state.go('board.project-detail.sbf-time-slot');
                });
            }]
        })
        .state('board.project-detail.sbf-time-slot.edit', {
            parent: 'board.project-detail.sbf-time-slot',
            url: '/{sbfId}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/sbf-time-slot/sbf-time-slot-dialog.html',
                    controller: 'SbfTimeSlotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SbfTimeSlot', function(SbfTimeSlot) {
                            return SbfTimeSlot.get({id : $stateParams.sbfId}).$promise;
                        }],
                        entityProject: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.sbf-time-slot', null, { reload: 'board.project-detail.sbf-time-slot' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.sbf-time-slot.delete', {
            parent: 'board.project-detail.sbf-time-slot',
            url: '/{sbfId}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/sbf-time-slot/sbf-time-slot-delete-dialog.html',
                    controller: 'SbfTimeSlotDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SbfTimeSlot', function(SbfTimeSlot) {
                            return SbfTimeSlot.get({id : $stateParams.sbfId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.sbf-time-slot', null, { reload: 'board.project-detail.sbf-time-slot' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
